(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 75557:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(86424);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 17288:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ useAuth; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var src_context_AuthContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35639);


const useAuth = ()=>(0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(src_context_AuthContext__WEBPACK_IMPORTED_MODULE_1__.AuthContext);


/***/ }),

/***/ 86424:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pages; },
  "getHomeRoute": function() { return /* binding */ getHomeRoute; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/hooks/useAuth.js
var useAuth = __webpack_require__(17288);
// EXTERNAL MODULE: ./src/@api/login.js + 1 modules
var login = __webpack_require__(53399);
// EXTERNAL MODULE: ./src/utils/i18n.js + 1 modules
var i18n = __webpack_require__(61906);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./src/utils/chooseDeviceRedirect.js
var chooseDeviceRedirect = __webpack_require__(99518);
// EXTERNAL MODULE: ./src/utils/switchDevice.js
var switchDevice = __webpack_require__(83989);
// EXTERNAL MODULE: ./src/utils/subscriptionExpire.js
var subscriptionExpire = __webpack_require__(96613);
// EXTERNAL MODULE: ./src/utils/subscriptionStatus.js
var subscriptionStatus = __webpack_require__(38365);
;// CONCATENATED MODULE: ./src/utils/bootstrapDeviceSelection.js



/**
 * 登录/首页选默认设备，与侧栏 switchDevice 走同一套流程。
 * 永不选中超 30 天失效设备；若传入 lapsed 会自动回退到可选设备或清空选中。
 * @param {Object} params
 * @param {import('redux').Dispatch} params.dispatch
 * @param {Object} [params.device] - 选中的设备记录
 * @param {string} [params.platformType] - 平台类型
 * @param {Array} [params.allDevices] - 全部设备列表，写入 allDeviceUser
 * @param {Object} [params.currentDevice] - 当前物理设备；刷新恢复会话时保留
 * @returns {ReturnType<import('src/utils/deviceContext').buildDeviceContext}|null}
 */ const bootstrapDeviceSelection = (param)=>{
    let { dispatch , device , platformType , allDevices , currentDevice  } = param;
    if (allDevices !== undefined) {
        localStorage.setItem("allDeviceUser", JSON.stringify(allDevices));
    }
    const mode = platformType || (device === null || device === void 0 ? void 0 : device.platform_type) || localStorage.getItem("currentMode") || "";
    const deviceList = Array.isArray(allDevices) ? allDevices : [];
    let nextDevice = device || null;
    if (nextDevice && !(0,subscriptionStatus/* isSelectableDevice */.He)(nextDevice)) {
        nextDevice = (0,subscriptionStatus/* pickPreferredSelectableDevice */.oT)(deviceList, mode) || (0,subscriptionStatus/* pickPreferredSelectableDevice */.oT)(deviceList) || null;
    }
    localStorage.setItem("Basic", (nextDevice === null || nextDevice === void 0 ? void 0 : nextDevice.iCloud_username) ? 1 : 0);
    return (0,switchDevice/* switchDevice */.m)({
        dispatch,
        deviceUser: nextDevice ? (0,subscriptionExpire/* buildDeviceUserPayload */.l)(nextDevice) : {},
        // 登录后的页面刷新必须保留当前物理设备，避免先以空设备状态渲染绑定流程。
        currentDevice: nextDevice && currentDevice !== undefined ? currentDevice : {},
        currentMode: mode,
        skipSelectionGuard: !nextDevice
    });
};

// EXTERNAL MODULE: ./src/components/expired-purchase-guide/constants.js
var constants = __webpack_require__(8009);
// EXTERNAL MODULE: ./src/utils/userEntryGate.js
var userEntryGate = __webpack_require__(1128);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(27484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ./src/components/Message/index.js + 1 modules
var Message = __webpack_require__(29143);
// EXTERNAL MODULE: ./src/utils/resolveCurrentOrderId.js
var resolveCurrentOrderId = __webpack_require__(32870);
;// CONCATENATED MODULE: ./src/pages/index.js
// ** React Imports



// ** Next Import

// ** Hook Imports














const dashboardPathByMode = (mode)=>{
    if (mode === "Android-Cloud") return "/android/dashboard";
    if (mode === "Android-Local") return "/android/local/dashboard";
    return "/dashboard";
};
/**
 *  Set Home URL based on User Roles
 */ const getHomeRoute = (role)=>{
    if (role === "client") return "/acl";
    else if (localStorage.getItem("currentMode") === "Android-Cloud") return "/android/dashboard";
    else return "/dashboard";
};
const Home = ()=>{
    const { t  } = (0,i18n/* useTranslation */.$G)("common");
    //当前页面语种
    const [currentLanguage, setCurrentLanguage] = (0,react.useState)("/");
    // useEffect(() => {
    //   // 函数用于更新 currentLanguage
    //   const updateLanguage = () => {
    //     const url = window.location.pathname
    //     // 使用正则表达式匹配语言代码，包括语言代码后可能没有任何路径的情况
    //     const match = url.match(/^\/(de|kr|it-ch|pt|jp|fr|es|tr|ar|[a-zA-Z]{2})($|\/)/)
    //     const language = match ? `/${match[1]}` : '/'
    //     setCurrentLanguage(language)
    //   }
    //   // 初始化时设置语言
    //   updateLanguage()
    //   // 监听浏览器历史记录的变化
    //   window.addEventListener('popstate', updateLanguage)
    //   // 处理前进和后退操作
    //   const handleNavigation = () => {
    //     updateLanguage()
    //   }
    //   // 监听 pushState 和 replaceState
    //   const originalPushState = window.history.pushState
    //   const originalReplaceState = window.history.replaceState
    //   window.history.pushState = function () {
    //     originalPushState.apply(this, arguments)
    //     handleNavigation()
    //   }
    //   window.history.replaceState = function () {
    //     originalReplaceState.apply(this, arguments)
    //     handleNavigation()
    //   }
    //   // 清理监听器
    //   return () => {
    //     window.removeEventListener('popstate', updateLanguage)
    //     window.history.pushState = originalPushState
    //     window.history.replaceState = originalReplaceState
    //   }
    // }, []) // 空依赖数组，表示只在组件加载时和卸载时执行一次
    // ** Hooks
    const dispatch = (0,es/* useDispatch */.I0)();
    const auth = (0,useAuth/* useAuth */.a)();
    const router = (0,next_router.useRouter)();
    let [loading, setLoading] = (0,react.useState)(true);
    const allUserDevice = async ()=>{
        return await (0,login.getAllUserDevice)({});
    };
    // 校验
    const verify = async (type)=>{
        let allDeviceUser = await allUserDevice();
        const data = Array.isArray(allDeviceUser.data) ? [
            ...allDeviceUser.data
        ] : [];
        const all = data.sort((a, b)=>dayjs_min_default()(b.createdAt) - dayjs_min_default()(a.createdAt));
        if (type == "iOS-Cloud") {
            if (all !== null && all.length > 0 && all[0]) {
                const _data = all.filter((row)=>row.platform_type === "iOS-Cloud");
                // 永不回退到超 30 天设备
                const selectedDevice = (0,subscriptionStatus/* pickPreferredSelectableDevice */.oT)(_data);
                if (selectedDevice) {
                    bootstrapDeviceSelection({
                        dispatch,
                        device: selectedDevice,
                        platformType: type,
                        allDevices: all
                    });
                } else {
                    // 没有可选绑定设备，验证是否有未绑定账单
                    const res = await (0,login.getNotBindOrder)({});
                    if (res.data && res.data.length) {
                        bootstrapDeviceSelection({
                            dispatch,
                            device: null,
                            platformType: type,
                            allDevices: all
                        });
                    } else {
                        throw new Error("No not bind order");
                    }
                }
            } else {
                const res1 = await (0,login.getNotBindOrder)({});
                if (res1.data && res1.data.length) {
                    bootstrapDeviceSelection({
                        dispatch,
                        device: null,
                        platformType: type,
                        allDevices: []
                    });
                } else {
                    throw new Error("No not bind order");
                }
            }
        } else if (type.indexOf("Android") >= 0) {
            if (all !== null && all.length > 0) {
                const _data1 = all.filter((row)=>row.platform_type === type);
                const selectedDevice1 = (0,subscriptionStatus/* pickPreferredSelectableDevice */.oT)(_data1);
                bootstrapDeviceSelection({
                    dispatch,
                    device: selectedDevice1,
                    platformType: type,
                    allDevices: all
                });
            } else {
                bootstrapDeviceSelection({
                    dispatch,
                    device: null,
                    platformType: type,
                    allDevices: []
                });
            }
        }
    };
    // useEffect(() => {
    //   if (auth.user && auth.user.role) {
    //     const homeRoute = getHomeRoute(auth.user.role)
    //     const type = async () => {
    //       let { data, order, deviceMany } = await verifyCurrentType()
    //       localStorage.setItem('deviceMany', deviceMany)
    //       // 类型
    //       if (data === 'not bind device' || order.length > 0 || deviceMany) {
    //         setLoading(false)
    //         return
    //       }
    //       // 定义路径映射
    //       const paths = {
    //         'iOS-Cloud': '/dashboard',
    //         'Android-Cloud': '/android/dashboard',
    //         'Android-Local': '/android/local/dashboard'
    //       }
    //       // 获取路径
    //       const path = paths[data]
    //       if (path) {
    //         // 验证数据
    //         verify(data).then(() => {
    //           // 更新 localStorage
    //           window.localStorage.setItem('currentMode', data)
    //           // 根据 currentLanguage 决定 fullPath
    //           const fullPath = currentLanguage === '/' ? path : `${currentLanguage}${path}`
    //           router.push(fullPath)
    //         })
    //       }
    //     }
    //     type()
    //   }
    //   // eslint-disable-next-line react-hooks/exhaustive-deps
    // }, [currentLanguage])
    (0,react.useEffect)(()=>{
        var ref;
        if (!((ref = auth.user) === null || ref === void 0 ? void 0 : ref.role)) return;
        const type = async ()=>{
            // 先查设备：已绑定设备应进 dashboard，不能仅因无未绑定订单被踢去买套餐
            const allDeviceUser = await (0,login.getAllUserDevice)({}) // 获取所有设备用户
            ;
            const data = (Array.isArray(allDeviceUser.data) ? [
                ...allDeviceUser.data
            ] : []).sort((a, b)=>dayjs_min_default()(b.createdAt) - dayjs_min_default()(a.createdAt)) // 检查数据是否是数组并按绑定时间排序
            ;
            const notBindOrder = await (0,login.getNotBindOrder)().catch(()=>({
                    data: []
                }));
            const validUnbound = (0,chooseDeviceRedirect/* filterValidUnboundOrders */.tA)(notBindOrder === null || notBindOrder === void 0 ? void 0 : notBindOrder.data);
            // 入口优先级：未购买 → 购买页；买过且全部订单过期超 30 天 → 过期页；其余走设备流程
            const flags = await (0,userEntryGate/* loadUserEntryFlags */.lf)();
            const entryType = (0,userEntryGate/* resolveUserEntry */.Ji)({
                flags,
                devices: data,
                validUnboundOrders: validUnbound
            });
            if (entryType === userEntryGate/* USER_ENTRY.BUY */.Tv.BUY) {
                (0,chooseDeviceRedirect/* redirectToChooseDevice */.ey)();
                setLoading(false);
                return;
            }
            if (entryType === userEntryGate/* USER_ENTRY.EXPIRED */.Tv.EXPIRED) {
                window.location.assign(constants/* EXPIRED_PURCHASE_PATH */.UU);
                setLoading(false);
                return;
            }
            if (data[0]) {
                const currentModeStr = localStorage.getItem("currentMode");
                const currentMode = currentModeStr || null;
                const DeviceUserStr = localStorage.getItem("DeviceUser");
                const DeviceUser = DeviceUserStr ? JSON.parse(DeviceUserStr) : null;
                // 先按 device_id 匹配（id 优先），匹配不上才用 iCloud 账号兜底。
                // 不能用「名称 OR id」混在一个 find 里：同邮箱多账号时前面的名称命中会盖掉后面的 id 命中。
                const hasDeviceId = (DeviceUser === null || DeviceUser === void 0 ? void 0 : DeviceUser.device_id) != null && (DeviceUser === null || DeviceUser === void 0 ? void 0 : DeviceUser.device_id) !== "";
                const matchedById = hasDeviceId ? data.find((i)=>{
                    return String(i === null || i === void 0 ? void 0 : i.id) === String(DeviceUser.device_id) || String(i === null || i === void 0 ? void 0 : i.device_id) === String(DeviceUser.device_id);
                }) : null;
                const matchedDevice = matchedById || data.find((i)=>{
                    return (i === null || i === void 0 ? void 0 : i.iCloud_username) === (DeviceUser === null || DeviceUser === void 0 ? void 0 : DeviceUser.username);
                });
                // active/grace 设备 > 未绑单 > 空态；「全部过期超 30 天」已由入口 gate 处理
                const entry = (0,subscriptionStatus/* resolveInitialEntry */.Mi)({
                    devices: data,
                    validUnboundOrders: validUnbound,
                    preferredMode: currentMode,
                    preferredDevice: matchedDevice || null
                });
                if (entry.type === "unbound" || entry.type === "empty") {
                    let setupOrderId = null;
                    if (validUnbound.length >= 1) {
                        setupOrderId = (0,resolveCurrentOrderId/* cacheBindOrder */.Ef)(validUnbound[0]);
                    } else if (await (0,chooseDeviceRedirect/* redirectIfShouldBuyPackage */.og)(notBindOrder)) {
                        setLoading(false);
                        return;
                    }
                    bootstrapDeviceSelection({
                        dispatch,
                        device: null,
                        platformType: currentMode || "iOS-Cloud",
                        allDevices: data
                    });
                    router.push((0,resolveCurrentOrderId/* appendSetupQuery */.Rb)("/setup", setupOrderId || undefined));
                    setLoading(false);
                    return;
                }
                const defaultDevice = entry.device;
                window.localStorage.setItem("currentMode", defaultDevice.platform_type);
                await verify(defaultDevice.platform_type);
                router.push(dashboardPathByMode(defaultDevice.platform_type));
            } else {
                const search =  true ? window.location.search : 0;
                const params = new URLSearchParams(search.startsWith("?") ? search.slice(1) : search);
                const queryOrderId = params.get("orderId") || params.get("order_id");
                if (params.get("from_app") === "1" && !queryOrderId) {
                    (0,Message/* messageInfo */.B)({
                        content: "Current order is missing"
                    });
                    setLoading(false);
                    return;
                }
                // 无设备时：无有效未绑定订单才去买套餐，否则走绑定 setup
                // 已有明确 orderId 时直接进 setup，避免被未绑定列表为空踢去买套餐
                let setupOrderId1 = queryOrderId;
                if (!setupOrderId1) {
                    if (await (0,chooseDeviceRedirect/* redirectIfShouldBuyPackage */.og)(notBindOrder)) {
                        setLoading(false);
                        return;
                    }
                    // 登录进 setup：默认选中第一张有效未绑单（排除过期单干扰计数）
                    if (validUnbound.length >= 1) {
                        setupOrderId1 = (0,resolveCurrentOrderId/* cacheBindOrder */.Ef)(validUnbound[0]);
                    }
                }
                router.push((0,resolveCurrentOrderId/* appendSetupQuery */.Rb)("/setup", setupOrderId1 || undefined));
            }
            setLoading(false);
        };
        type();
    }, [
        auth.user
    ]);
    // 选择平台
    const SelectPlatform = ()=>{
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    className: "text-[24px] text-[#000] font-[Poppins] font-[600] leading-[36px] text-center mx-[15px] Mlg:mt-[60px] mt-[78px] mb-[37px]",
                    children: t("Select the type of device want to monitoring")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "max-w-[728px] grid grid-cols-1 smjs:grid-cols-2 gap-[30px] mx-5 smjs:mx-auto",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "w-full h-[130px] cursor-pointer flex flex-col justify-center items-center [border:1px_solid_#0481FF] rounded-[10px] [background:linear-gradient(180deg,#ECF3FE_0%,#FDFEFF_100%)] hover:[background:linear-gradient(180deg,#D9E8FF_0%,#ECF3FE_100%)]",
                            onClick: ()=>{
                                // 上传ios日志
                                (0,login.iosLoginReport)({
                                    "platform": "ios-icloud",
                                    "site": "msafely",
                                    "s_1": 1
                                });
                                verify("iOS-Cloud").then(()=>{
                                    window.localStorage.setItem("currentMode", "iOS-Cloud");
                                    const path = "/dashboard";
                                    router.push(path);
                                });
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: "/images/bind/ios.svg",
                                    alt: "ios",
                                    width: 41,
                                    height: 48,
                                    className: "w-[41px] h-[48px]"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex justify-center items-center mt-[9px]",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "text-[20px] text-[#222222] font-[Poppins] font-bold leading-[30px]",
                                            children: t("iOS")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: "/images/bind/arrow.svg",
                                            alt: "arrow",
                                            width: 6,
                                            height: 12,
                                            className: "w-[6.01px] h-[11.66px] ml-2"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "w-full h-[130px] cursor-pointer flex flex-col justify-center items-center [border:1px_solid_#0481FF] rounded-[10px] [background:linear-gradient(180deg,#ECF3FE_0%,#FDFEFF_100%)] hover:[background:linear-gradient(180deg,#D9E8FF_0%,#ECF3FE_100%)]",
                            onClick: async ()=>{
                                // 获取所有设备用户
                                const allDeviceUser = await allUserDevice();
                                // 检查数据是否是数组
                                const data = Array.isArray(allDeviceUser.data) ? allDeviceUser.data : [];
                                // 确定要跳转的路径
                                let path = "/android/classification" // 默认路径
                                ;
                                if (data.some((row)=>row.platform_type === "Android-Cloud")) {
                                    verify("Android-Cloud").then(()=>{
                                        window.localStorage.setItem("currentMode", "Android-Cloud");
                                        path = "/android/dashboard";
                                        // 跳转到目标路径
                                        router.push(path);
                                    });
                                    return;
                                } else if (data.some((row)=>row.platform_type === "Android-Local")) {
                                    verify("Android-Local").then(()=>{
                                        window.localStorage.setItem("currentMode", "Android-Local");
                                        path = "/android/local/dashboard";
                                        // 跳转到目标路径
                                        router.push(path);
                                    });
                                    return;
                                }
                                window.localStorage.setItem("currentMode", "Android-Cloud");
                                // 跳转到目标路径
                                router.push(path);
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: "/images/bind/android.svg",
                                    alt: "android",
                                    width: 42,
                                    height: 50,
                                    className: "w-[42.31px] h-[50px]"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex justify-center items-center mt-[9px]",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "text-[20px] text-[#222222] font-[Poppins] font-bold leading-[30px]",
                                            children: t("Android")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: "/images/bind/arrow.svg",
                                            alt: "arrow",
                                            width: 6,
                                            height: 12,
                                            className: "w-[6.01px] h-[11.66px] ml-2"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
};
/* harmony default export */ var pages = (Home);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5675,9518,5639,9774,2888,179], function() { return __webpack_exec__(75557); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);